export enum DeliveryIssueTypeDomestic {
    LATE_DELIVERY = 'Late Delivery',
    EARLY_DELIVERY = 'Early Delivery',
    CUSTOMER_REFUSED_SHIPMENT = 'Customer Refused Shipment',
    MISSING_BOX = 'Missing Box',
    DELIVERED_TO_WRONG_ADDRESS = 'Delivered to Wrong Address',
    PACKING_LIST_QR_CODE = 'Packing List QR Code'
}
